import axios from "axios";

const requestStatus = {};

const specificUrls = [
  "/api/contact/filter",
  "/api/activity/get-last-note-contacts",
  "/api/pin/get-by-user"
];

const getUrlSpecific = (url) => {
  // if (url !== "/api/message/filter") return url
  // if (!data.msgTypes || !data.msgTypes.length) return url
  // if (data.msgTypes.includes('chat.photo')) {
  //   return "/api/message/filterMedia"
  // } else if (data.msgTypes.includes('share.file')) {
  //   return "/api/message/filterFile"
  // } else if (data.msgTypes.includes('chat.link')) {
  //   return "/api/message/filterLink"
  // }
  return url;
}

const apiLogRequest = (apiName, axiosRequest) => {
  console.group &&
    console.group(
      '%cAPI Request',
      'color:white;font-weight:bold;background:#0194ff;padding:2px 6px',
      apiName
    );
  console.log('HTTP Method\t\t', axiosRequest.method.toUpperCase());
  console.log('Endpoint\t\t', axiosRequest.url);
  axiosRequest.data && console.log('Request Body\t', axiosRequest.data);
  console.log('AXIOS Request\t', axiosRequest);
  console.groupEnd && console.groupEnd();
};

const apiLogResponse = (apiName, axiosResponse) => {
  console.log(axiosResponse);
  console.group &&
    console.group(
      '%cAPI Response',
      'color:white;font-weight:bold;background:green;padding:2px 6px',
      apiName
    );
  console.log('HTTP Method\t\t', axiosResponse.config.method.toUpperCase());
  console.log('Endpoint\t\t', axiosResponse.config.url);
  axiosResponse.config.data && console.log('Request Body\t', axiosResponse.config.data);
  axiosResponse.data && console.log('Response Body\t', axiosResponse.data);
  console.log('AXIOS Response\t', axiosResponse);
  console.groupEnd && console.groupEnd();
};

const apiLogError = (apiName, error) => {
  console.log('error', error);
  console.group &&
    console.group(
      '%cAPI Response',
      'color:white;font-weight:bold;background:red;padding:2px 6px',
      apiName
    );
  console.log('HTTP Method\t\t', error.config.method.toUpperCase());
  console.log('Endpoint\t\t', error.config.url);
  error && error.config.data && console.log('Request Body\t', error.config.data);
  error && error.data && console.log('Response Body\t', error.data);
  console.log('AXIOS Error\t', error);
  console.groupEnd && console.groupEnd();
};

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Authorization': `Bearer ` + localStorage.getItem("bearerToken"),
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

instance.interceptors.request.use(
  (config) => {
    const url = getUrlSpecific(config.url, config.data)
    if (specificUrls.includes(url)) {
      if (requestStatus[url] && requestStatus[url].isExecuting) {
        requestStatus[url].cancel('Operation canceled by the user.');
      }
      requestStatus[url] = {
        isExecuting: true,
        cancel: null,
      };
      config.cancelToken = new axios.CancelToken(function (cancel) {
        requestStatus[url].cancel = cancel;
      });
    }

    config.headers.Authorization = `Bearer ` + localStorage.getItem("bearerToken");
    if (process.env.NODE_ENV === 'development') {
      apiLogRequest('UNKNOWN', config);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const url = getUrlSpecific(response.config.url, response.config.data)
    if (specificUrls.includes(url)) {
      requestStatus[url].isExecuting = false;
    }

    if (process.env.NODE_ENV === 'development') {
      apiLogResponse('UNKNOWN', response);
    }
    return response.data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    const url = getUrlSpecific(error.config?.url, error.config?.data)
    if (specificUrls.includes(url)) {
      requestStatus[url].isExecuting = false;
    }

    if (process.env.NODE_ENV === 'development') {
      if (error.response) {
        const apiName = error.config.url || 'UNKNOWN';
        apiLogError(apiName, error.response);
      } else if (error.request) {
        const apiName = error.config.headers['X_HEADER_API_LOG'] || 'UNKNOWN';
        apiLogError(apiName, error.request);
      } else {
        console.log('API Error', error.message);
      }
    }
    return error.response?.data;
  }
);

export var HTTP = instance
